/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Notfoundanswer2Inputs */

const he_faq_notfoundanswer2 = /** @type {(inputs: Faq_Notfoundanswer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לא מצאתם את התשובה שחיפשתם?`)
};

const en_faq_notfoundanswer2 = /** @type {(inputs: Faq_Notfoundanswer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Didn't find what you were looking for?`)
};

/**
* | output |
* | --- |
* | "Didn't find what you were looking for?" |
*
* @param {Faq_Notfoundanswer2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const faq_notfoundanswer2 = /** @type {((inputs?: Faq_Notfoundanswer2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Notfoundanswer2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_faq_notfoundanswer2(inputs)
	return en_faq_notfoundanswer2(inputs)
});
export { faq_notfoundanswer2 as "faq_notFoundAnswer" }